// extracted by mini-css-extract-plugin
export default {"linesWrapper":"Summary_linesWrapper__rHbCt"};